import axios from "axios";
import { baseUrl } from "../URL";
import { headers } from "../headers";

export const updateIdentifiant = async(values) =>{
    return await axios.post(baseUrl("modifiermotdepasse"),values,headers);
};
